import { BarProps, useAnimateBar } from "@mui/x-charts-pro";

export const VENDOR_EPISODIC_SERIES_ID = "vendorEpisodic";
export const E_MANIFEST_EPISODIC_SERIES_ID = "eManifestEpisodic";
const EPISODIC_SERIES_IDS = new Set([VENDOR_EPISODIC_SERIES_ID, E_MANIFEST_EPISODIC_SERIES_ID]);

/** How far an episodic block reaches down over its source bar, hiding that bar's rounded top and outline. */
const EPISODIC_SEAT = 3;

export function ShipmentBar(props: BarProps) {
  const {
    ownerState,
    id,
    style,
    skipAnimation: _skipAnimation,
    dataIndex: _dataIndex,
    xOrigin: _xOrigin,
    yOrigin: _yOrigin,
    ...rest
  } = props;
  const isEpisodic = EPISODIC_SERIES_IDS.has(String(id)) && props.height > 0;
  const animated = useAnimateBar(
    isEpisodic ? { ...props, height: props.height + EPISODIC_SEAT } : props
  );
  return (
    <rect
      {...rest}
      style={isEpisodic ? { ...style, stroke: "none" } : style}
      filter={ownerState.isHighlighted ? "brightness(120%)" : undefined}
      opacity={ownerState.isFaded ? 0.3 : 1}
      data-highlighted={ownerState.isHighlighted || undefined}
      data-faded={ownerState.isFaded || undefined}
      {...animated}
    />
  );
}
